import { ToastViewport } from "@/legacy/react/ui";

export function LegacyToastViewport() {
  return <ToastViewport />;
}
